import { render, staticRenderFns } from "./EventScanTable.vue?vue&type=template&id=1671df96"
import script from "./EventScanTable.vue?vue&type=script&lang=js"
export * from "./EventScanTable.vue?vue&type=script&lang=js"
import style0 from "./EventScanTable.vue?vue&type=style&index=0&id=1671df96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports